"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Backdrop = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var Backdrop = /** @class */ (function (_super) {
    __extends(Backdrop, _super);
    function Backdrop(props) {
        var _this = _super.call(this, props) || this;
        _this.transitionEndState = null;
        _this.transitionEnd = function () {
            if (_this.transitionEndState) {
                _this.setState(_this.transitionEndState);
                _this.transitionEndState = null;
            }
        };
        _this.state = {
            inDom: props.isOpen,
            isOpen: props.isOpen,
        };
        return _this;
    }
    Backdrop.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        if (!prevProps.isOpen && this.props.isOpen) {
            // The backdrop is being opened
            if (!this.props.fade) {
                // No fading, make visible immediately
                this.setState({
                    inDom: true,
                    isOpen: true,
                });
            }
            else {
                // Open with fade. After backdrop is added to the DOM, the
                // CSS transition can be applied.
                this.setState({
                    inDom: true,
                }, function () {
                    _this.setState({
                        isOpen: true,
                    });
                });
            }
        }
        if (prevProps.isOpen && !this.props.isOpen) {
            // The backdrop is being closed
            if (!this.props.fade) {
                // No fading, hide immediately
                this.setState({
                    inDom: false,
                    isOpen: false,
                });
            }
            else {
                // Close with fade. Start CSS transition.
                this.setState({
                    isOpen: false,
                });
                // When CSS transition completes, remove backdrop from the DOM
                this.transitionEndState = {
                    inDom: false,
                };
            }
        }
    };
    Backdrop.prototype.render = function () {
        if (!this.state.inDom) {
            return null;
        }
        var classes = 'modal-backdrop';
        if (this.props.fade) {
            classes += ' fade';
        }
        if (this.state.isOpen) {
            classes += ' show';
        }
        return (React.createElement("div", { className: classes, onTransitionEnd: this.transitionEnd }));
    };
    return Backdrop;
}(React.Component));
exports.Backdrop = Backdrop;
/* tslint:disable:no-string-literal */
Backdrop['defaultProps'] = {
    fade: false,
    isOpen: false,
};
Backdrop['propTypes'] = {
    fade: PropTypes.bool,
    isOpen: PropTypes.bool,
};
/* tslint:enable:no-string-literal */
